<template>
  <div>
    <div v-if="history && history.length > 0">
      <div class="table-responsive">
        <table class="table table-centered table-bordered table-nowrap mb-0 table-hover">
          <thead class="thead-light">
            <tr>
              <th style="width: 150px">{{ $t("audit-control.history.date_user") }}</th>
              <th>{{ $t("audit-control.history.action.text") }}</th>
            </tr>
          </thead>
          <tbody>
            <tr v-for="item in paginatedHistory" :key="item.date">
              <td>
                <small class="d-block text-muted">{{ item.date | date }}</small>
                <span class="font-weight-bold">{{ item.performedBy.name }} {{ item.performedBy.surname || "" }}</span>
              </td>
              <td>
                <b-badge :variant="getActionVariant(item.action)">{{ $t(`task.history.action.${item.action}`) || item.action }}</b-badge>
                <div v-if="item.description" class="small text-muted mt-1">{{ item.description }}</div>

                <!-- Display Changes -->
                <div v-if="item.changes" class="mt-2">
                  <ul class="list-unstyled mb-0 sm">
                    <li v-for="(change, key) in item.changes" :key="key" class="font-size-11">
                      <span class="font-weight-bold">{{ $t(`task.${key}`) || key }}:</span>
                      <span class="text-danger">{{ formatValue(change.old) }}</span>
                      <i class="iconoir-arrow-right mx-1"></i>
                      <span class="text-success">{{ formatValue(change.new) }}</span>
                    </li>
                  </ul>
                </div>
              </td>
            </tr>
          </tbody>
        </table>
      </div>
      <div class="row mt-4">
        <div class="col">
          <b-pagination v-if="history.length > perPage" v-model="currentPage" :total-rows="history.length" :per-page="perPage" limit="10" size="sm"></b-pagination>
        </div>
      </div>
    </div>
    <empty v-else>
      <h5 class="text-center">{{ $t("common.no-data") }}</h5>
    </empty>
  </div>
</template>

<script>
export default {
  props: {
    history: {
      type: Array,
      default: () => [],
    },
  },
  data() {
    return {
      currentPage: 1,
      perPage: 10,
    };
  },
  computed: {
    paginatedHistory() {
      // Sort desc by date
      const sorted = [...this.history].sort((a, b) => new Date(b.date) - new Date(a.date));
      const start = (this.currentPage - 1) * this.perPage;
      const end = start + this.perPage;
      return sorted.slice(start, end);
    },
    currentLanguage() {
      return this.$i18n.locale;
    },
  },
  methods: {
    getLocalizedValue(val) {
      if (!val) return "";
      if (typeof val !== "object") return val;
      return val[this.$i18n.locale] || val.en || val.tr || "";
    },
    formatValue(val) {
      if (val === null || val === undefined) return "-";
      if (typeof val === "object" && val !== null) {
        if (val.tr || val.en) {
          return val[this.currentLanguage] || val.tr || val.en;
        }
        if (val.name) {
          return this.getLocalizedValue(val.name);
        }
        if (val instanceof Date || (typeof val === "string" && val.match(/^\d{4}-\d{2}-\d{2}/))) {
          return new Date(val).toLocaleDateString();
        }
        return JSON.stringify(val);
      }
      return val;
    },
    getActionVariant(action) {
      switch (action) {
        case "CREATED":
          return "success";
        case "UPDATED":
          return "info";
        case "STATUS_CHANGED":
          return "primary";
        case "EXTENSION_REQUESTED":
          return "warning";
        case "EXTENSION_EVALUATED":
          return "success";
        default:
          return "secondary";
      }
    },
  },
};
</script>
